export interface IOperatorRingtime {
    sessionId: string;
    isSuccess: boolean;
    data: IOperatorRingtimeData[];
}

export interface IOperatorRingtimeData {
    ringTime: number;
}

export const DefaultRingtime: IOperatorRingtime = {
    sessionId: '',
    isSuccess: false,
    data: [],
};
